import React, { useState, useEffect } from "react";
import classes from "./bulkadd.module.scss";
import moment from 'moment';
import {
    FormControlLabel,
    Checkbox,
    FormControl,
    TextField,
    Button,
    Grid,
    Box,
    Typography,
    InputLabel,
    Select,
    IconButton
  } from '@mui/material';
import { Icon, DatePicker, Dialog, useToggle, DataGrid } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { center, methods } from "underscore";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin, convertDateToMMDDYYYYString, toUpperCaseString } from "../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import DragDrop from "./DragDrop";
import { InfoOutlinedIcon} from '@genesis/ui-kit/dist/icons'
import { DownloadFileIcon,ProcessionIcon,UnableToProcessIcon,PartiallyProcessedIcon,ProcessingCompleteIcon, RefreshIcon } from "../../../../Resources/availabilityicon/IconUtils";
import SnackBar from "../../../../Shared/Snackbar/Snackbar"
import { FileStatus } from "./FileStatus";
import ProgressBar from "./ProgressBar";
import Tooltip from '@mui/material/Tooltip';

const BulkAdd = () => {
    const personDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookies.get('X_TKN');
    const history = useNavigate();
    const [uploadHistoryList, setUploadHistoryList] = useState([]);
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [filteredFiles, setFilteredFiles] = useState(null);
    const [uploadDisable, setUploadDisable] = useState(true);
    const [dialogDisplay, setDialogDisplay] = useState(false);
    const [duplicateFileName, setDuplicateFileName] = useState([]);

    const dialog = useToggle();
    const [uploadPercent, setUploadPercent] = useState(0);

    // check user role at page
    CheckIsUserAdmin();

    useEffect(()=>{
      getAllUploadHistory();
     
    },[]);

    // upload multiplart request 
    const uploadMultiplartRequestCall = () =>{
      //Prepare request payload
      var fileData = new FormData();
      Array.prototype.slice.call(selectedFiles).forEach(myFile => {
        fileData.append('files', myFile);
      });

      axios({
        method: "post",
        url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPLOAD_FILES_BULK_ADD}`,
        data: fileData,
        headers: { 
          'Content-Type' : 'multipart/form-data',
          'Authorization': 'Bearer ' + token
          },
      })
        .then(function (response) {
          //handle success
          setUploadPercent(100);
          setTimeout(() => {
            setSelectedFiles([]);
            setUploadPercent(0);
          }, 2000);
          
          getAllUploadHistory();
        })
        .catch(function (response) {
          //handle error
          setUploadDisable(false);
          console.log("Upload Failed"+response);
          setAlertOpen({
            open: true,
            severity: "error",
            message: "Unable to upload files.Please try again.",
          });
         
        });
      

      
    }
    

    // validate duplicate file name from history data
    const foundDuplicateFileName = () => {
      // implememt validation logic
      const fileNames = uploadHistoryList.map(fileHistory => fileHistory.originalFileName);   
      const selFiles = Array.prototype.slice.call(selectedFiles).map(file => file.name);  
      let isFound = selFiles.some(file => fileNames.includes(file));
      let duplicateFileN = selFiles.filter((file) => fileNames.includes(file));
      setDuplicateFileName(duplicateFileN);
      //console.log("selFiles+"+ selFiles + "File Found"+ fileNames + isFound );
      return isFound;
      
    }
    // onUplod Action 
    const onUploadAction = () => {
      // do the duplicate name validations here 
     let validationStatus =  !foundDuplicateFileName();

     //: display the Duplicate file name proceed with overwrite modal
     //: on Yes..proceed to upload
     //: on NO.. dismiss dialog
      // call the upload API with filtered list
      if(validationStatus){
        uploadMultiplartRequestCall();
      }else{
       dialog.show();
       setDialogDisplay(true);
      }
    }

    // get all upload history network call
    const getAllUploadHistory = () => {
      //Network API request to get All divisions
      axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_FILE_STATUS_HISTORY}`, {
        headers: {
          'content-type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
        .then((res) => {
          console.log("Upload History", res.data);
          let tmparr = []

       res.data.map(obj => {
        let tmpobj = {}
        //console.log("obj",obj)
        tmpobj.id = obj.aefId;
        tmpobj.filename = obj.fileName;
        tmpobj.originalFileName = obj.originalFileName;
        tmpobj.lastupdated = moment(obj.lastUpdateDate).format("DD MMM YYYY HH:mm ");
        tmpobj.filesize = obj.fileSize;
        tmpobj.fileStatus = obj.fileStatus;
        tmpobj.fileMessage = obj.fileMessage;
        tmpobj.status = obj.fileStatus + " : " + obj.fileMessage;
        tmpobj.errorfilename= obj.errorFileName;
        tmparr.push(tmpobj);
      });
          setUploadHistoryList(tmparr);
        })
        .catch((err) => {
         //
         console.log("ErR" + err.response.data.message);
         if(err.message === 'Network Error') {
           history("/somethingwentwrong", {state:`Please logout and try again `})
         } else {
         history("/somethingwentwrong", {state:`${constants.WFM_FILE_STATUS_HISTORY}...failed. ${err.response.data.message}`})
         }
        })
    }
    // handle refreh Grid
    const handleRefreshGrid = () =>{
      // recall the get all status API call here;
      getAllUploadHistory();
    }
    // on select files
    const handleOnFilesSelection = (files) => {
      let selFiles = Array.prototype.slice.call(files); 
      setSelectedFiles(files);
    }
    // handle file select error
    const handleFileSelectError = () => {
      setAlertOpen({
           open: true,
           severity: "error",
           message: "Unable to upload file. Please make sure it’s a spreadsheet with a .xlsx format and try again.",
         });
   }  
    
  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  // handle file removal after selection
  const handleFileRemove = (filename) => {
    console.log("my files", selectedFiles)
    const selFiles = Array.prototype.slice.call(selectedFiles).filter(file => file.name !=filename);
    setSelectedFiles(selFiles) 
  }

  // handle download error file
  const handleDownloadFile = (fName) => {
    //Network API request to get All divisions
    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_DOWNLOAD_FILE}`,
     {
      responseType:"arraybuffer",
      params: {
        fileName: fName
      }
    })
      .then((response) => {
        // create file link in browser's memory
        let fileN = response.config.params.fileName;
        var blob = new Blob([response.data]);
        var href = URL.createObjectURL(blob);
    //create "a" HTML element with href to file & click
     const link = document.createElement('a');
     link.href = href;
     link.setAttribute('download', fileN); //or any other extension
     document.body.appendChild(link);
     link.click();
    // // clean up "a" element & remove ObjectURL
     document.body.removeChild(link);
     URL.revokeObjectURL(href);
      })
      .catch((err) => {
        //
        //alert(""+ JSON.stringify(err));
       setAlertOpen({
        open: true,
        severity: "error",
        message: "Unable to download file.Please try again.",
      });
      })

  }

    const columns = [
     
      { field: 'originalFileName', headerName: 'Original File Name', width: "230", flex: 1 },
      { field: 'filename', headerName: 'Processed File Name', width: "230", flex:1.2  },
      { field: 'lastupdated', headerName: 'Last Updated', width: "170",flex:0.8},
      { field: 'filesize', headerName: 'File Size', width: "100",flex:0.6 },
      { field: 'status', headerName: 'Status', width: "470" ,flex:2.2, renderCell: (params) => {
        let rowData = params.row;
        let fileStatus = params.row.fileStatus.toUpperCase();
        
        if(fileStatus == FileStatus.STATUS_UPLOAD_COMPLETE.toUpperCase()){
          return <div><Tooltip title={rowData.fileMessage}><div style={{display: "flex" , gap: "5px"}}><ProcessingCompleteIcon/><div>{rowData.status}</div></div></Tooltip></div>
        }else if(fileStatus == FileStatus.STATUS_UNABLE_TO_PROCESS.toUpperCase() || fileStatus == FileStatus.STATUS_UNABLE_TO_UPLOAD.toUpperCase()){
          return <div><Tooltip title={rowData.fileMessage}><div style={{display: "flex" , gap: "5px", color: "red"}}><UnableToProcessIcon/><div>{rowData.status}</div></div></Tooltip></div>
        }else if(fileStatus == FileStatus.STATUS_PROCESSING.toUpperCase()){
          return <div><Tooltip title={rowData.fileMessage}><div style={{display: "flex" , gap: "5px"}}><ProcessionIcon/><div>{rowData.status}</div></div></Tooltip></div>
        }else if(fileStatus == FileStatus.STATUS_PARTIALLY_PROCESSED.toUpperCase()){
          return <div><Tooltip title={rowData.fileMessage}><div style={{display: "flex" , gap: "5px"}}><PartiallyProcessedIcon/><div>{rowData.status}</div></div></Tooltip></div>
        }else if(fileStatus == FileStatus.STATUS_PROCESSING_FAILED.toUpperCase()){
          return <div><Tooltip title={rowData.fileMessage}><div style={{display: "flex" , gap: "5px"}}><UnableToProcessIcon/><div>{rowData.status}</div></div></Tooltip></div>
        }else if(fileStatus == FileStatus.STATUS_PROCESSING_COMPLETED.toUpperCase()){
          return <div><Tooltip title={rowData.fileMessage}><div style={{display: "flex" , gap: "5px"}}><ProcessingCompleteIcon/><div>{rowData.status}</div></div></Tooltip></div>
        }
      } },
      { field: 'actions', headerName: 'Actions', width: "80",flex:0.5, renderCell: (params) => {
        let record = params.row;
        let status = record.fileStatus.toUpperCase();
        if(status.includes(FileStatus.STATUS_PROCESSING_COMPLETED.toUpperCase()) || status.includes(FileStatus.STATUS_PROCESSING_FAILED.toUpperCase()) || status.includes(FileStatus.STATUS_PARTIALLY_PROCESSED.toUpperCase())){
          return <div style={{paddingLeft:"15px"}} onClick={() => handleDownloadFile(params.row.errorfilename)}><DownloadFileIcon /></div>
        }else{
        return <div></div>
      }
      } },

    ]; 

return(<div className={classes.pagemargin}>
  <div className={classes.pagetitle} >Bulk Add</div>
  <div className={classes.pagesubtitle}>Upload Files</div>
  {/* Upload area */}
  <div className={classes.icon_text}>
    <InfoOutlinedIcon/>
  <div className={classes.fileInst}>Only spreadsheets with .xlsx format can be processed.</div>
  </div>

  <DragDrop
  handleFileSelectError={handleFileSelectError}
  handleOnFilesSelection={handleOnFilesSelection}/>

  <br/>
  {/* Status progress show here */}
  <ProgressBar files={selectedFiles} handleFileRemove={handleFileRemove} uploadPercent={uploadPercent}  />
  
  <div style={{"marginTop": "20px", marginBottom: "30px"}}>
    <Button style={{paddingLeft: "60px", paddingRight: "60px"}} disabled={!(Array.prototype.slice.call(selectedFiles).length > 0)} onClick={() =>onUploadAction()}>Upload</Button>
  </div>

  

  {/* Upload History UI  */}
  <div className={classes.pagesubtitle}>Upload History</div>
  <div   style={{fontSize:"14px" , display: "flex", justifyContent: "flex-end", marginTop: "-30px", marginRight: "20px"}}>
  <Button  
  color="secondary" 
  onClick={handleRefreshGrid}
  startIcon={<RefreshIcon/>} >Refresh</Button >
</div>
  <AdminControlsDataGrid 
  columns= { columns} 
  rows = {uploadHistoryList} 
  width={"100%"} 
  height={500} 
  disableSelectionClick={true} />          

<SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
      {/* dialog modal */}
      { dialogDisplay && 
      <Dialog
        open={dialog.open}
        title='Duplicate File Found'
        onClose={dialog.hide}
        actions={
          <>
            <Button color="secondary"onClick={() => {
              setDialogDisplay(false)}}>No</Button>
            <Button onClick={()=>{
            setDialogDisplay(false)
            uploadMultiplartRequestCall();
            }}>Yes</Button>
          </>
        }
      >
        <Typography>{duplicateFileName && duplicateFileName.join(",")} already exists. Uploading it again will override Event/Location Control details. Is that what you want to do?</Typography>
      </Dialog>
    }
  </div>); 
}

export default BulkAdd;
